import update from 'immutability-helper';

import {
    REQUEST_POSTS,
    RECEIVE_POSTS,
    SET_STATIC_HTML
} from '../actions/posts';

const initialState = {
    isLoading: false,
    content: '',
    staticHtml: ''
};

function posts(state = initialState, action) {
    switch (action.type) {
        case REQUEST_POSTS:
            return update(state, {
                isLoading: { $set: true },
                content: { $set: '' },
                staticHtml: { $set: '' }
            });

        case RECEIVE_POSTS:
            return update(state, {
                isLoading: { $set: false },
                content: { $set: action.content }
            });

        case SET_STATIC_HTML:
            return update(state, { staticHtml: { $set: action.html } });

        default:
            return state;
    }
}

export default posts;



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/reducers/posts.js